export default __webpack_public_path__ + "static/media/island_7.f7809b55.png";